export default __webpack_public_path__ + "static/icon-a7c551ae9bddc09054b0e47f93c3490b.png";